import { useEffect, useState } from "react";
import useDebounce from "./useDebounce";

// Server-side search for a picker: while `enabled` (say, while its dropdown is open) it calls
// `fetchResults(search)` as the user types, debounced, and keeps the latest answer. An earlier
// answer that arrives late never replaces a newer one.
const useRemoteSearch = (fetchResults, { enabled = true, delay = 300 } = {}) => {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, delay);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    let current = true;
    setLoading(true);
    Promise.resolve(fetchResults(debouncedSearch.trim())).then((answer) => {
      if (!current) return;
      setResult(answer);
      setLoading(false);
    });
    return () => {
      current = false;
    };
    // fetchResults is usually an inline function; a new one each render must not search again
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, debouncedSearch]);

  return { search, setSearch, result, loading };
};

export default useRemoteSearch;
